import { useQueryClient } from '@tanstack/react-query'
import { PencilIcon } from 'lucide-react'

import CustomizeBenchmarksDropdown, { type CustomizeBenchmarksDropdownProps } from 'components/quoting/quotes/benchmark_suggestions/CustomizeBenchmarksDropdown'
import { IconButton } from 'slab'
import { getGetQuotingQuoteResultsQuoteIdQueryKey } from 'utils/web_api'

type Props = Omit<CustomizeBenchmarksDropdownProps, 'trigger' | 'onSuccess'>

export default function UpdateBenchmarks ({
  prospectId,
  quoteId,
  quoteGenerationOptions,
  preserveInitialValues
}: Props) {
  const queryClient = useQueryClient()
  const onSuccess = () => {
    queryClient.invalidateQueries({
      queryKey: getGetQuotingQuoteResultsQuoteIdQueryKey(quoteId),
    })
  }

  return (
    <CustomizeBenchmarksDropdown
      prospectId={prospectId}
      quoteId={quoteId}
      quoteGenerationOptions={quoteGenerationOptions}
      onSuccess={onSuccess}
      align='start'
      preserveInitialValues={preserveInitialValues}
      trigger={
        <IconButton
          icon={PencilIcon}
          size='large'
          label='Update benchmarks'
        />
      }
    />
  )
}
